import { render } from "./SwdModalTerms.vue?vue&type=template&id=629ff9fe"
import script from "./SwdModalTerms.vue?vue&type=script&lang=js"
export * from "./SwdModalTerms.vue?vue&type=script&lang=js"

import "./SwdModalTerms.vue?vue&type=style&index=0&id=629ff9fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__